/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Discover_Desc8Inputs */

const en_svc_mvp_sprint_discover_desc8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two calls and one doc: users, core loop, and what is explicitly out of scope.`)
};

const ar_svc_mvp_sprint_discover_desc8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مكالمتان ومستند واحد: المستخدمون والحلقة الأساسية وما هو خارج النطاق صراحة.`)
};

const bn_svc_mvp_sprint_discover_desc8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দুটি কল আর একটি ডক: ব্যবহারকারী, মূল লুপ, আর যা স্পষ্টভাবে সুযোগের বাইরে।`)
};

const de_svc_mvp_sprint_discover_desc8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwei Calls und ein Dokument: Nutzer, Kernschleife und was ausdrücklich außerhalb des Umfangs liegt.`)
};

const es_svc_mvp_sprint_discover_desc8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos llamadas y un documento: usuarios, ciclo principal y lo que queda explícitamente fuera del alcance.`)
};

const fr_svc_mvp_sprint_discover_desc8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux appels et un document : utilisateurs, boucle principale et ce qui est explicitement hors périmètre.`)
};

const pt_svc_mvp_sprint_discover_desc8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas chamadas e um documento: utilizadores, ciclo principal e o que fica explicitamente fora do âmbito.`)
};

const zh_svc_mvp_sprint_discover_desc8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两次通话加一份文档：用户、核心链路，以及明确不做的事情。`)
};

const tr_svc_mvp_sprint_discover_desc8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İki görüşme ve bir belge: kullanıcılar, ana döngü ve kapsam dışı kalanlar.`)
};

const ru_svc_mvp_sprint_discover_desc8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Два звонка и один документ: пользователи, главный цикл и что явно вне скоупа.`)
};

const pl_svc_mvp_sprint_discover_desc8 = /** @type {(inputs: Svc_Mvp_Sprint_Discover_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dwie rozmowy i jeden dokument: użytkownicy, główna pętla i to, co wyraźnie poza zakresem.`)
};

/**
* | output |
* | --- |
* | "Two calls and one doc: users, core loop, and what is explicitly out of scope." |
*
* @param {Svc_Mvp_Sprint_Discover_Desc8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_discover_desc8 = /** @type {((inputs?: Svc_Mvp_Sprint_Discover_Desc8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Discover_Desc8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_discover_desc8(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_discover_desc8(inputs)
	if (locale === "de") return de_svc_mvp_sprint_discover_desc8(inputs)
	if (locale === "es") return es_svc_mvp_sprint_discover_desc8(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_discover_desc8(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_discover_desc8(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_discover_desc8(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_discover_desc8(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_discover_desc8(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_discover_desc8(inputs)
	return en_svc_mvp_sprint_discover_desc8(inputs)
});
export { svc_mvp_sprint_discover_desc8 as "svc_mvp-sprint_DISCOVER_desc" }